angular.module('smartorg.r6.mgmts.restrict', [
    require('../../../../../../components/list-selector/app/js/plumbing/app'),
]);
require('./restrict-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.restrict';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/restrict/app/js/plumbing/app.js